"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

exports.deviceInfo = deviceInfo;
exports.shouldCallHandlerOnWindowResize = shouldCallHandlerOnWindowResize;

function deviceInfo() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

function shouldCallHandlerOnWindowResize() {
  var prevDimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _deviceInfo = deviceInfo(),
      width = _deviceInfo.width,
      height = _deviceInfo.height;

  return prevDimensions.width !== width || prevDimensions.height !== height;
}

;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(deviceInfo, "deviceInfo", "/Users/mmarinich/WebstormProjects/react-alice-carousel/src/lib/utils/device.js");
  reactHotLoader.register(shouldCallHandlerOnWindowResize, "shouldCallHandlerOnWindowResize", "/Users/mmarinich/WebstormProjects/react-alice-carousel/src/lib/utils/device.js");
  leaveModule(module);
})();

;